import { useCallback, useMemo } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Session-ID leeft enkel binnen het browsertabblad (zoals in de originele app).
export function getSessionId() {
  try {
    let id = sessionStorage.getItem('immo_demo_session');
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`);
      sessionStorage.setItem('immo_demo_session', id);
    }
    return id;
  } catch {
    return 'anon';
  }
}

export function useDemoTracking(context) {
  const sessionId = useMemo(getSessionId, []);
  const track = useCallback((event, payload = {}) => {
    try {
      fetch(`${API}/demo/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: String(event).slice(0, 64),
          session_id: sessionId,
          context,
          payload,
          ts: new Date().toISOString(),
          ua: (navigator.userAgent || '').slice(0, 200),
        }),
      }).catch(() => {});
    } catch {}
  }, [context, sessionId]);
  return { track, sessionId };
}
